import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import Wire24Logo from 'assets/logo-for-loader.svg';
import { useTheme } from 'hooks/useTheme';

export const FullScreenSpinner = ({ onComplete }) => {
  const { theme, background, darkMode } = useTheme();

  return (
    <div
      id="loading-screen"
      className={`fixed inset-0 z-50 flex flex-col items-center justify-center overflow-hidden text-white ${theme}`}
    >
      {/* Background pattern */}
      <div className="absolute inset-0">
        <img
          src={background}
          alt="Background Pattern"
          className="w-full h-full object-cover opacity-20"
        />
        {/* Glassmorphism overlay for subtle blur and dark tint */}
        <div className="absolute inset-0 bg-black/40 dark:bg-black/60 backdrop-blur-2xl" />
      </div>

      {/* Centered content */}
      <div className="relative z-10 flex flex-col items-center animate-[blur-fade_2.4s_ease-in-out_infinite]">
        {/* Glowing Logo Loader */}
        <div className="relative w-40 h-40 mb-4">
          <div className="absolute inset-0 rounded-full bg-white/20 blur-xl animate-pulse z-0" />
          <img
            src={Wire24Logo}
            alt="Wire24 Logo"
            className="relative z-10 w-full h-full"
          />
        </div>

        {/* Animated "Loading..." */}
        <p className="mt-2 text-sm text-white/80 dark:text-white/60 flex items-center">
          Loading, please wait
          {[0, 0.2, 0.4].map((delay, idx) => (
            <motion.span
              key={idx}
              initial={{ opacity: 0 }}
              animate={{ opacity: [0, 1, 0] }}
              transition={{ repeat: Infinity, duration: 1.2, ease: 'easeInOut', delay }}
            >
              .
            </motion.span>
          ))}
        </p>
      </div>

      {/* Animation keyframes */}
      <style>
        {`
          @keyframes blur-fade {
            0%, 100% {
              backdrop-filter: blur(10px);
              opacity: 0.95;
            }
            50% {
              backdrop-filter: blur(14px);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
};

FullScreenSpinner.propTypes = {
  onComplete: PropTypes.func,
};
